import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ac40de1e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container inner" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
    key: 1,
    class: "contact_details"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    class: "no-style contact_details__email",
    href: "mailto:studio@absolute.agency"
}, "studio@absolute.agency", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    class: "no-style contact_details__telephone",
    href: "tel:01204699566"
}, "Bolton: 01204 699 566", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    class: "no-style contact_details__telephone",
    href: "tel:02045388086"
}, "London: 020 4538 8086", -1));
const _hoisted_7 = [
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
];
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'cta_banner',
    props: ['d'],
    setup(__props) {
        const ctaBanner = ref(null);
        const isScrolledIntoView = ref(false);
        // Intersection Observer setup
        onMounted(() => {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // 0.5 means when 50% of the element is visible
            };
            const callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        isScrolledIntoView.value = true;
                        observer.unobserve(entry.target);
                    }
                });
            };
            const observer = new IntersectionObserver(callback, options);
            observer.observe(ctaBanner.value);
        });
        return (_ctx, _cache) => {
            const _component_arrow = _resolveComponent("arrow");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["cta_banner", { 'scrolled': isScrolledIntoView.value }]),
                ref_key: "ctaBanner",
                ref: ctaBanner,
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "top_text",
                        innerHTML: __props.d.top_text
                    }, null, 8, _hoisted_2),
                    (__props.d.show_arrow == 'true')
                        ? (_openBlock(), _createBlock(_component_arrow, { key: 0 }))
                        : _createCommentVNode("", true),
                    (__props.d.show_contact_details == 'true')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
                        : _createCommentVNode("", true)
                ])
            ], 6));
        };
    }
});
